define('views/shared/form/input/phone_component',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/form/input/phone_component.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'form-input',
        tagName  : 'div',
        isRender : false,
        template : _.template(Template),
        events   : {
            'blur input': 'inputBlur',
            'focus input': 'inputFocus',
            'keydown input': 'keydownValidatePhone',
            'keyup input': 'keyupValidatePhone'
        },

        phone: {
            valid   : null,
            value   : null,
            empty   : true,
            active  : false,
            touched : false,
            complete: false
        },

        initialize: function(options){
            options = options || {};

            this.context = options.context;

            this.field = options.field;

            this.is_valid = false;
            this.error = false;
            this.error_feedback = this.field.error.empty;
            this.patterns = Backbone.Validation.patterns;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            // if autocomplete is false and we're in chrome
            if (!this.field.autocomplete && window.chrome) {  
                this.field.autocomplete = 'autocomplete-off-' + (new Date()).getTime();
            }            

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){

            this.render();
            
        },

        updateValue: function(val){
            this.$el.find('input').val(val);
            this.formatPhone();
            this.keyupValidatePhone();
        },

        getValue: function(){
            return encrypt(this.phone.value);
        },

        checkField: function(){

            if(this.phone.valid){
                this.is_valid = true;
            } else {
                this.is_valid = false;
            }

        },

        showError: function(){

            this.checkField();

            if(!this.is_valid){
                this.$el.find('.js-form-input-feedback').html(this.error_feedback);
            } else {
                this.removeError();
            }

        },

        removeError: function(){
            this.$el.find('.js-form-input-feedback').html('');
        },


        /*
            Focus Event
        */

        
        inputFocus: function(){
            this.phone.touched = true;
            this.phone.active = true;
        },

        /*
            Blur Event
        */

        inputBlur: function(){
            this.phone.active = false;
            this.validatePhone();
        },

        validatePhone: function(){
            var input_value = (this.phone.value) ? this.phone.value : '',
                area_code = input_value.slice(0,3),
                first_three = input_value.slice(3,6),
                last_four = input_value.slice(6);

            if(input_value.length == 10){

                if(this.patterns.number.test(this.phone.value) == false) {
                    
                    this.error_feedback = this.field.error.invalid;
                    this.is_valid = false;
                    this.showError();

                } else if(this.phone.value.length != 10) {                    
                    
                    this.error_feedback = this.field.error.invalid;
                    this.is_valid = false;
                    this.showError();

                } else {

                    this.phone.complete = true;
                    this.is_valid = true;
                    this.removeError();

                }

            } else {
                this.phone.valid = false;
                this.error_feedback = this.field.error.empty;

                if(this.phone.touched && !this.phone.active){
                    this.showError();
                }
                
            }

        },

        keyupValidatePhone: function(e){
            var val = this.$el.find('input').val(),
                true_value = val.split(' ').join('').replace('-', '').replace('-', '').replace('(', '').replace(')', ''),
                new_value = true_value.replace(/(.{3})/g, '$1/'),
                middle_value = true_value.replace(/(.{3})(.{3})/g, '$1-$2-'),
                last_value = true_value.replace(/(.{3})(.{3})(.{4})/g, '$1-$2-$3'),
                len = true_value.length;

            this.phone.value = true_value;

            if(len == 3 && e && e.keyCode != 46 && e.keyCode != 8){

                var new_value = true_value.replace(/(.{3})/g, '$1-');
                this.$el.find('input').val(new_value);

                this.phone.empty = false;

            } else if(len == 6 || len == 10 && e && e.keyCode != 46 && e.keyCode != 8){
                
                var new_value = true_value.replace(/(.{3})(.{3})/g, '$1-$2-');
                this.$el.find('input').val(new_value);

                this.phone.empty = false;

            } else if(len == 10){
                
                var new_value = true_value.replace(/(.{3})(.{3})/g, '$1-$2-');
                this.$el.find('input').val(new_value);

            }

            // Validate and format phone number
            if(len == 10 || len == 0){

                if(len == 10){
                    
                    this.phone.complete = true;
                    this.phone.empty = false;

                    this.field.empty = false;

                    this.is_valid = true;
                    
                } else {

                    this.phone.empty = true;

                    this.is_valid = false;

                    this.field.empty = true;

                }

                this.validatePhone();
                
            }

            return false;

        },

        keydownValidatePhone: function(e){
            
            switch(true){
                case e.keyCode >= 48 && e.keyCode <= 57:   // Numbers
                case e.keyCode >= 96 && e.keyCode <= 105:  // Numberpad
                case e.keyCode == 37:   // Left Arrow
                case e.keyCode == 39:   // Right Arrow
                case e.keyCode == 8:    // Backspace
                case e.keyCode == 46:   // Delete
                case e.keyCode == 32:   // Space
                case e.keyCode == 9:    // Tab
                case e.keyCode == 191:  // Forward Slash
                case e.keyCode == 111:  // Forward Slash
                case e.keyCode == 91:   // Command
                case e.keyCode == 16:   // Shift
                case e.keyCode == 17:   // Control
                case e.keyCode == 18:   // Control
                case e.keyCode == 86:   // V Character
                case e.keyCode == 82:   // R Character
                    this.phone.touched = true;
                    this.formatPhone(e);
                    // console.log('keydownValidatePhone',e.keyCode, this);
                    break;
                default:
                    return false;
                    break;
            }
            
        },

        formatPhone: function(e){
            var val = this.$el.find('input').val(),
                true_value = val.split(' ').join('').replace('-', '').replace('-', '').replace('(', '').replace(')', ''),
                new_value = true_value.replace(/(.{3})/g, '$1-'),
                len = true_value.length;

            this.phone.complete = false;

            if(len == 0){
                this.phone.empty = true;
                this.validatePhone();
            } else if(len >= 10 && e && e.keyCode != 46 && e.keyCode != 8 && e.keyCode != 9){

                if(e && e.preventDefault){ e.preventDefault(); }
                if(e && e.stopPropagation){ e.stopPropagation(); }

            }

        },

        close: function(){}
    });
});

